module.exports = __webpack_public_path__ + "img/add-folder-o.4c726880.svg";